import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=54506d0e&scoped=true"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"
import style0 from "./Default.vue?vue&type=style&index=0&id=54506d0e&prod&lang=css"
import style1 from "./Default.vue?vue&type=style&index=1&id=54506d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54506d0e",
  null
  
)

export default component.exports